import React, { useEffect, useState } from 'react'
import Modal from '../../common/modal'
import { Box, Button, Stack, Tab, Tabs } from '@mui/material'
import { connect } from 'react-redux'
import { updateModal } from '../../../store/common/common_action'
import { Item } from '../../common/snippets'
import LineInput from '../../common/lineinput'
import DropDownOA from '../../common/dropDownOA'
import { SEL_BOOKING_TYPE } from '../../common/constants'
import { getPaymentMode } from '../../common/paymentsMode'
import { paymentModes } from '../../common/paymentsMode'
import * as iid from '../../common/bookingElementId'
import PropTypes from 'prop-types'
import SenderReceiverTab from './SendRecDetailChange'
import EwayBillTab from './EWayBillTab'
import BookingDeliveryTab from './BookingDeliveryTab'
import ConsignmentBookingCharge from './ConsignmentBookingCharge'
//import VehicleDispatchTab from './VehicleDispatchTab'

const TabPopup = (props) => {
  const { updateModal, data } = { ...props }
  const [senderSect] = useState(
    props.selectedRadio === 'showLr'
      ? ['SENDER/RECEIVER DETAIL CHANGE']
      : props.selectedRadio === 'adminUpdate'
      ? ['SENDER/RECEIVER DETAIL CHANGE', 'EWAY BILL UPDATE', 'BOOKING/DELIVERY CHARGE']
      : ['SENDER/RECEIVER DETAIL CHANGE', 'EWAY BILL UPDATE', 'CONSIGNMENT/BOOKING CHARGE UPDATE']
  )
  const [senderSectContent, setSenderSectContent] = useState(props.senderSectContent)
  const [selectLr, setSelectLr] = useState(props.lrDetail)
  const handleSenderSect = (event, newValue) => {
    setSenderSectContent(newValue)
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    )
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }
  return (
    <Modal
      headTxt={
        senderSectContent === 0
          ? `Sender Receiver Details Change`
          : senderSectContent === 1
          ? 'Eway Bill Update'
          : props?.selectedRadio === 'modify'
          ? 'Consignment/Booking Charge Update'
          : 'Booking / Delivery Charge'
      }
      width={'95%'}
      updateModal={updateModal}
    >
      <Stack>
        <Item sx={{ width: '100%', margin: '0px', padding: '10px 0' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            {/* <Tabs value={senderSectContent} onChange={handleSenderSect} aria-label="bsic tabs example">
              {senderSect.map((reqType, index) => (
                <Tab key={`sender_${index}`} label={reqType} {...a11yProps(index)} />
              ))}
            </Tabs> */}
          </Box>
        </Item>
        {senderSectContent === 0 ? (
          <SenderReceiverTab selectLr={selectLr} updateData={props.updateData} setOnClosePopup={props.onClosePopup} />
        ) : (
          ''
        )}
        {senderSectContent === 1 ? <EwayBillTab selectLr={selectLr} setOnClosePopup={props.onClosePopup} /> : ''}
        {senderSectContent === 2 ? (
          props?.selectedRadio === 'modify' ? (
            <ConsignmentBookingCharge selectLr={selectLr} updateData={props.updateData} setOnClosePopup={props.onClosePopup} />
          ) : (
            <BookingDeliveryTab selectLr={selectLr} updateData={props.updateData} setOnClosePopup={props.onClosePopup}  />
          )
        ) : (
          ''
        )}
      </Stack>
    </Modal>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(TabPopup)
